var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main home"},[_c('slideshow'),_vm._v(" "),_c('novita'),_vm._v(" "),_c('div',{staticClass:"module col-2 stretch-parent max-width side-padding"},[_c('featuredVideo'),_vm._v(" "),_c('registerBanner01')],1),_vm._v(" "),_c('homeCatalogue')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71a10ff0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/Home.vue
// module id = 453
// module chunks = 0